const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  divider: {},
  couponGrid: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  innerGrid: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    spacing: 2,
  },
  rootHeader: {
    maxWidth: 1280,
  },
  typographyHeader: {
    color: 'var(--mcg-dark, #002E47)',
    textAlign: 'center',
    fontFamily: 'Inter',
    fontSize: '32px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '150%',
    marginTop: '40px',
    width: '100%',
    maxWidth: 1280,
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  successGrid: {
    maxWidth: 300,
    margin: '0 auto',
    justifyContent: 'center',
    height: '100%',
    width: '100%',
  },
  image: {
    width: '100%',
    height: undefined,
  },
  checkIcon: {
    fontSize: 22,
    color: 'green',
  },
  table: {
    maxWidth: 800,
    margin: '0 auto',
    marginTop: '20px',
  },
  tableTitle: {
    fontWeight: 'bold',
    fontSize: 16,
  },
  tableHeader: {
    fontWeight: 'bold',
    fontSize: 20,
    paddingLeft: '15px !important',
  },
  tableHead: {
    padding: 15,
  },
  icon: {
    marginTop: 6,
  },
  gridItem: {
    minWidth: 'max-content',
  },
  warningGrid: {
    maxWidth: 300,
    //margin: '0 auto',
    //justifyContent: 'center',
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
  },
  currentPlanBadge: {
    display: 'flex',
    padding: '12px 24px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 8,
    borderRadius: 32,
    fontFamily: 'Inter',
    fontSize: 16,
    fontWeight: 500,
    lineHeight: 'normal',
    marginTop: 24,
  },
  audienceToggle: {
    display: 'inline-flex',
    backgroundColor: '#fff',
    borderRadius: 12,
    padding: 6,
    marginTop: 8,
    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.06)',
    border: '1px solid rgba(0, 0, 0, 0.05)',
  },
  audienceOption: {
    padding: '12px 40px',
    borderRadius: 8,
    fontSize: 18,
    fontFamily: 'Inter',
    fontWeight: 700,
    color: '#002E47',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    userSelect: 'none',
    '&:hover': {
      color: '#015FFB',
    },
  },
  audienceActive: {
    backgroundColor: '#015FFB',
    color: '#fff',
    '&:hover': {
      color: '#fff',
    },
  },
  billingToggle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
    marginTop: 32,
    marginBottom: 40,
  },
  billingLabel: {
    fontSize: 14,
    fontFamily: 'Inter',
    fontWeight: 500,
    color: '#637381',
    cursor: 'pointer',
    userSelect: 'none',
  },
  billingLabelActive: {
    fontWeight: 700,
    color: '#002E47',
  },
  billingSwitch: {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    flexShrink: 0,
    height: 24,
    width: 44,
    padding: 0,
    border: 'none',
    borderRadius: 9999,
    backgroundColor: 'rgba(0, 0, 0, 0.15)',
    cursor: 'pointer',
    transition: 'background-color 0.2s ease',
  },
  billingSwitchOn: {
    backgroundColor: '#015FFB',
  },
  billingKnob: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 16,
    width: 16,
    borderRadius: '50%',
    backgroundColor: '#fff',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)',
    transform: 'translateX(4px)',
    transition: 'transform 0.2s ease',
  },
  billingKnobOn: {
    transform: 'translateX(24px)',
  },
  billingBadge: {
    borderRadius: 9999,
    padding: '2px 10px',
    fontSize: 12,
    fontFamily: 'Inter',
    fontWeight: 700,
    color: '#fff',
    backgroundColor: '#637381',
    transition: 'background-color 0.2s ease',
  },
  billingBadgeOn: {
    backgroundColor: '#015FFB',
  },
})

export default styles
